import $ from 'jquery';
// import modernizr from 'modernizr';
// import './jquery.placeholder.min.js';
import 'jquery-placeholder';
// import Sloth from '../Sloth';

$(document).ready(() => {
    $('input').placeholder();
});



/** WEBPACK FOOTER **
 ** ./components/Placeholder/placeholder.js
 **/